import {
  getNameDescriptionTableColumn,
  getTimeTableColumn,
  getCopyWithContentTableColumn,
} from '@/utils/common/tableColumn'
import { numerify } from '@/filters'
import i18n from '@/locales'

export default {
  created () {
    this.columns = [
      getCopyWithContentTableColumn({
        field: 'id',
        title: i18n.t('scope.text_438'),
      }),
      getNameDescriptionTableColumn({
        field: 'title',
        title: i18n.t('scope.text_439'),
        edit: false,
        onManager: this.onManager,
        hideField: true,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{ row.title }</side-page-trigger>
          )
        },
      }),
      {
        field: 'count',
        title: i18n.t('scope.text_440'),
      },
      {
        field: 'origin_amount',
        title: i18n.t('scope.text_441'),
        formatter: ({ cellValue }) => {
          return numerify(cellValue, '0,0.00')
        },
      },
      {
        field: 'amount',
        title: i18n.t('scope.text_298'),
        formatter: ({ cellValue }) => {
          return numerify(cellValue, '0,0.00')
        },
      },
      {
        field: 'currency',
        title: i18n.t('scope.text_442'),
      },
      getTimeTableColumn({ title: i18n.t('scope.text_834') }),
      getTimeTableColumn({ title: i18n.t('scope.text_446'), field: 'deadline' }),
    ]
  },
}
